import { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import { Loading } from "../UI";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ThemeProvider } from "styled-components";
import { pink, green, purple, blue } from "../UI/themes";
import styled from "styled-components";
import backImg from "../assets/img/back_img.png";
import { useMobile } from "../utils/mobile";

const LayoutContainer = styled.div(({ theme, isMobile }) => ({
  height: "100vh",
  width: "100vw",
  minHeight: "100vh",
  margin: 0,
  padding: 0,
  background: !isMobile ? `url(${backImg}) no-repeat center center fixed` : 'unset',
  backgroundColor: theme.color.gray10,
  backgroundSize: "cover",
  overflow: "hidden",
}));

const LoadingContainer = (props) => {
  const { isLoading, children } = props;
  if (isLoading) {
    return <Loading loading={isLoading} />;
  }
  return <>{children}</>;
};
const Layout = ({ userStore, tenantsStore, ...props }) => {
  const { i18n } = useTranslation();
  const [selectedTheme, setSelectedTheme] = useState(blue);
  const isMobile = useMobile();

  useEffect(() => {
    i18n.changeLanguage(userStore.language);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStore.language]);

  const rtlOrLtr = i18n.dir();

  const getCurrentTheme = (themeString) => {
    switch (themeString) {
      case "pink":
        return pink;
      case "green":
        return green;
      case "purple":
        return purple;
      case "blue":
        return blue;
      default:
        return blue;
    }
  };

  useEffect(() => {
    const body = document.body;
    body.dir = rtlOrLtr;
  }, [rtlOrLtr]);

  useEffect(() => {
    document.title = "Coralis";
    const currentThemeString = JSON.parse(
      localStorage.getItem("coralis-tenants-storeuser")
    )?.selectedTheme;
    if (currentThemeString) {
      const currentTheme = getCurrentTheme(currentThemeString);

      setSelectedTheme(currentTheme);
    }
  }, []);

  useEffect(() => {
    const currentTheme = getCurrentTheme(tenantsStore.selectedTheme);

    setSelectedTheme(currentTheme);
  }, [tenantsStore.selectedTheme, tenantsStore.selectedProject]);

  return (
    <>
      <ThemeProvider theme={selectedTheme}>
        <LayoutContainer isMobile={isMobile}>
          <LoadingContainer isLoading={false}>
            {props.children}
          </LoadingContainer>
          <Outlet />
        </LayoutContainer>
      </ThemeProvider>
    </>
  );
};

export default inject("userStore", "tenantsStore")(observer(Layout));
